<template>
  <section>
    <loading-flux :value="loading"></loading-flux>
    <v-simple-table class="elevation-3">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-center">Acción</th>
            <th class="text-left">Código de SAP</th>
            <th class="text-left">Descripción</th>
            <th class="text-center">Precio Neto</th>
            <th class="text-right">Cantidad</th>
            <th class="text-center">Monto Neto</th>
            <th class="text-center">IVA</th>
            <th class="text-center">Monto Total</th>
            <th class="text-center">Estado</th>
            <th class="text-center">Pago Completado</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="service in requestService.items" :key="service.id">
            <td>
              <v-menu :close-on-content-click="true">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" class="blue lighten-2" fab x-small outlined>
                    <v-icon color="white"> mdi-dots-vertical </v-icon>
                  </v-btn>
                </template>
                <v-list rounded>
                  <v-list-item
                    class=""
                    @click="
                      emitOpenModalItemsHes({
                        description: requestService.description,
                        sap_code: requestService.sap_code,
                        ...service,
                      })
                    "
                  >
                    <v-list-item-title x-small class="pointer">
                      <v-badge
                        bordered
                        :color="
                          service.created_hes.length ||
                          service.inventory_entries.length
                            ? 'green'
                            : 'red'
                        "
                        :content="
                          getAllHes(service).length
                            ? getAllHes(service).length
                            : '0'
                        "
                        overlap
                      >
                        <v-icon color="blue lighten-1"> mdi-eye </v-icon>
                      </v-badge>
                      <span class="mx-1"> Ver Hes </span>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    class=""
                    @click="
                      emitOpenModalGenerateHes({
                        ...service,
                        sap_code: requestService.sap_code,
                        request_id: requestService.id,
                        project: requestService.project,
                        cost_center: requestService.cost_center,
                        is_cost_center: requestService.cost_center
                          ? true
                          : false,
                        sap_stage: requestService.stage_code,
                      })
                    "
                    v-if="
                      service.status !== HES_STATUS_PAY_TEXT &&
                        getPercentageOc(service) < 100
                    "
                  >
                    <v-list-item-title x-small class="pointer">
                      <v-icon class="mr-1" color="success">
                        mdi-currency-usd
                      </v-icon>
                      <span class="mx-1"> Generar Hes </span>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
            <td>
              <p class="my-0 text-left" style="font-size: 12px">
                {{ service.material.code }}
              </p>
            </td>
            <td>
              <p class="text-left my-0" style="font-size: 12px">
                {{ service.material ? service.material.name : "-" }}
              </p>
            </td>
            <td>
              <div class="d-flex justify-content-center">
                <p class="my-0 mt-1" style="font-size: 12px">
                  {{
                    service.price
                      ? `${new Intl.NumberFormat("de-DE").format(
                          Number(service.price)
                        )}`
                      : "Por definir"
                  }}
                  {{ service.currency ? service.currency : "CLP" }}
                </p>
              </div>
            </td>
            <td>
              <p class="my-0 text-right" style="font-size: 12px">
                {{ service.quantity }}
              </p>
            </td>
            <td>
              <div class="d-flex justify-content-center">
                <p class="my-0 mt-1" style="font-size: 12px">
                  {{
                    service.total
                      ? `${new Intl.NumberFormat("de-DE").format(
                          Number(service.total)
                        )}`
                      : "Por definir"
                  }}
                  {{ service.currency ? service.currency : "CLP" }}
                </p>
              </div>
            </td>
            <td>
              <div class="d-flex justify-content-center">
                <p class="my-0 mt-1" style="font-size: 12px">
                  {{
                    service.applied_tax
                      ? `${new Intl.NumberFormat("de-DE").format(
                          Number(service.applied_tax)
                        )}`
                      : "-"
                  }}
                  {{
                    !service.applied_tax
                      ? ""
                      : service.currency
                      ? service.currency
                      : "CLP"
                  }}
                </p>
              </div>
            </td>
            <td>
              <div class="d-flex justify-content-center">
                <p class="my-0 mt-1" style="font-size: 12px">
                  {{
                    service.price_with_tax
                      ? `${new Intl.NumberFormat("de-DE").format(
                          Number(service.price_with_tax)
                        )}`
                      : "-"
                  }}
                  {{
                    !service.price_with_tax
                      ? ""
                      : service.currency
                      ? service.currency
                      : "CLP"
                  }}
                </p>
              </div>
            </td>
            <td class="text-right">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    :color="getColorStatus(service)"
                    v-bind="attrs"
                    v-on="on"
                    class="text-white"
                  >
                    <span style="font-size: 12px">
                      {{ getTextStatus(service) }}
                    </span>
                  </v-chip>
                </template>
                <span>{{ getTextStatus(service) }}</span>
              </v-tooltip>
            </td>
            <td>
              <v-progress-linear
                rounded
                :value="getPercentageOc(service)"
                color="light-green darken-1"
                class=""
                height="25"
              >
                <template v-slot:default="{ value }">
                  <strong
                    style="font-size: 12px"
                    :class="Math.ceil(value) == 100 ? 'text-white' : ''"
                    >{{
                      value.toLocaleString("es-ES", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    }}%
                  </strong>
                </template>
              </v-progress-linear>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { preventCloseIfNotKeyEventEsc } from "@/helpers/common";
import { mapActions } from "vuex/dist/vuex.common.js";
import { authUsuarioComputed } from "@/state/helpers";
import {
  HES_STATUS_LIST,
  HES_STATUS_PAY,
  HES_STATUS_PENDING,
  HES_STATUS_PARTIAL,
  HES_STATUS_PAY_TEXT,
  HES_STATUS_PENDING_TEXT,
  getAllHes,
} from "@/constants/supplying/hes";
export default {
  props: {
    requestService: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      currentRequestServiceId: null,
      listStatusPayment: HES_STATUS_LIST,
      HES_STATUS_PAY,
      HES_STATUS_PAY_TEXT,
      HES_STATUS_PENDING,
      HES_STATUS_PARTIAL,
    };
  },
  methods: {
    ...mapActions({}),
    getAllHes,
    getColorStatus(item) {
      if (
        item.status === HES_STATUS_PAY_TEXT ||
        this.getPercentageOc(item) >= 100
      ) {
        return "light-green darken-1";
      }
      if (getAllHes(item).length) {
        return "blue lighten-1";
      }
      if (item.status === HES_STATUS_PENDING_TEXT) {
        return "warning lighten-1";
      }
      return "primary";
    },
    getTextStatus(item) {
      if (
        item.status === HES_STATUS_PAY_TEXT ||
        this.getPercentageOc(item) >= 100
      ) {
        return HES_STATUS_LIST[1].text;
      }
      if (getAllHes(item).length) {
        return HES_STATUS_LIST[3].text;
      }
      if (item.status === HES_STATUS_PENDING_TEXT) {
        return HES_STATUS_LIST[2].text;
      }
      return HES_STATUS_LIST[3].text;
    },
    getPercentageOc(service) {
      if (service.status === HES_STATUS_PAY_TEXT) {
        return 100;
      }

      // let appliedTax = service.applied_tax ? service.applied_tax : 0;
      let totalAmountService = service.total;

      let totalAmount = 0;
      getAllHes(service).forEach((hes) => {
        totalAmount += hes.quantity * (service.total / service.quantity);
      });
      return (totalAmount / totalAmountService) * 100;
    },
    emitOpenModalItemsHes(item) {
      this.$emit("emitOpenModalItemsHes", item);
    },
    emitOpenModalGenerateHes(item) {
      this.$emit("emitOpenModalGenerateHes", item);
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({}),
  },
};
</script>

<style></style>